import { Directive, InjectionToken, Input } from '@angular/core';
export const PREFIX_DIRECTIVE: InjectionToken<PrefixDirective> =
  new InjectionToken<PrefixDirective>('PrefixDirective');

@Directive({
  selector: '[lyceoIconPrefix], [lyceoTextPrefix]',
  providers: [{ provide: PREFIX_DIRECTIVE, useExisting: PrefixDirective }],
  standalone: true,
})
export class PrefixDirective {
  @Input()
  public set lyceoTextPrefix(value: '') {
    this.isText = true;
  }

  public isText: boolean = false;
}
